/**
 * Which tabs the side panel has.
 *
 * Kept apart from the components so both the panel and the strip of icons can name
 * a tab without either importing the other.
 */

export type TabName = 'inventory' | 'combat' | 'skills' | 'quests' | 'friends' | 'settings';

/** The heading shown at the top of the panel for each tab. */
export const TAB_LABELS: Readonly<Record<TabName, string>> = {
  inventory: 'Inventory',
  combat: 'Fighting',
  skills: 'Skills',
  quests: 'Quests',
  friends: 'Friends',
  settings: 'Settings',
};
